export default __webpack_public_path__ + "static/media/dialogue-pop.8e8b3fcc.png";